import React, { useState } from 'react';
import { Agent, Message } from '../../../types/flzhub';
import { FlzAgentDetail } from './FlzAgentDetail';
import { FlzMessageList } from './FlzMessageList';
import { getAgentColor, getAgentInitials, getRoleLabel } from './Shared';

interface Props {
  agents: Agent[];
  messages: Message[];
  input: string;
  setInput: (v: string) => void;
  sendMessage: () => void;
  sending: boolean;
  search: string;
  isAdmin?: boolean;
  onLoadMore?: () => void;
  hasMore?: boolean;
  loadingMore?: boolean;
  broadcastMode?: boolean;
  setBroadcastMode?: (v: boolean) => void;
}

export const FlzChat: React.FC<Props> = ({ agents, messages, input, setInput, sendMessage, sending, search, isAdmin, onLoadMore, hasMore, loadingMore, broadcastMode, setBroadcastMode }) => {
  const [selectedAgent, setSelectedAgent] = useState<Agent | null>(null);
  const [showDetail, setShowDetail] = useState(false);

  const filteredAgents = agents.filter(a =>
    a.agent_name.toLowerCase().includes(search.toLowerCase())
  );

  // Agent seçilince o agent'ın mesajlarını filtrele
  const filteredMessages = selectedAgent
    ? messages.filter(m => m.agent_id === selectedAgent.id)
    : messages;

  const handleAgentClick = (agent: Agent) => {
    if (selectedAgent?.id === agent.id) {
      // Aynı agent'a tıklayınca seçimi kaldır
      setSelectedAgent(null);
      setShowDetail(false);
    } else {
      setSelectedAgent(agent);
      setShowDetail(true);
    }
  };

  return (
    <div style={{ display: 'flex', height: '100%' }}>
      {/* Agent List */}
      <div style={{ width: 180, borderRight: '1px solid var(--os-border)', overflowY: 'auto', padding: 8, flexShrink: 0 }}>
        {/* "All" button */}
        <button
          onClick={() => { setSelectedAgent(null); setShowDetail(false); }}
          style={{
            display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '6px 8px', borderRadius: 8, border: 'none', cursor: 'pointer', textAlign: 'left',
            background: !selectedAgent ? 'rgba(99,102,241,0.12)' : 'transparent', color: 'inherit', marginBottom: 4,
          }}
        >
          <div style={{ width: 22, height: 22, borderRadius: '50%', background: '#6366f1', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 800, flexShrink: 0 }}>
            All
          </div>
          <div style={{ overflow: 'hidden' }}>
            <div style={{ fontSize: 10, fontWeight: 700 }}>All Messages</div>
            <div style={{ fontSize: 8, color: 'var(--os-muted)' }}>{messages.length} total</div>
          </div>
        </button>

        {filteredAgents.map(a => (
          <button
            key={a.id}
            onClick={() => handleAgentClick(a)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '6px 8px', borderRadius: 8, border: 'none', cursor: 'pointer', textAlign: 'left',
              background: selectedAgent?.id === a.id ? 'rgba(99,102,241,0.12)' : 'transparent', color: 'inherit'
            }}
          >
            <div style={{ width: 22, height: 22, borderRadius: '50%', background: getAgentColor(a.agent_name), color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 800, flexShrink: 0 }}>
              {getAgentInitials(a.agent_name)}
            </div>
            <div style={{ overflow: 'hidden' }}>
              <div style={{ fontSize: 10, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.agent_name}</div>
              <div style={{ fontSize: 8, color: 'var(--os-muted)' }}>Lv.{a.level} · {getRoleLabel(a.id)}</div>
            </div>
          </button>
        ))}
      </div>

      {/* Message Area — filtered by selected agent */}
      <FlzMessageList
        messages={filteredMessages}
        input={input}
        setInput={setInput}
        sendMessage={sendMessage}
        sending={sending}
        isAdmin={isAdmin}
        onLoadMore={selectedAgent ? undefined : onLoadMore}
        hasMore={selectedAgent ? false : hasMore}
        loadingMore={loadingMore}
        broadcastMode={broadcastMode}
        setBroadcastMode={setBroadcastMode}
      />

      {/* Detail Area — only when agent selected */}
      {showDetail && selectedAgent && <FlzAgentDetail agent={selectedAgent} />}
    </div>
  );
};
